import type { EngineRoomView } from '../lib/sections';

export function EngineRoomViewSelector({
  view,
  onView,
}: {
  readonly view: EngineRoomView;
  readonly onView: (view: EngineRoomView) => void;
}) {
  return (
    <div className="engine-room-view-selector" role="group" aria-label="Engine Room views">
      <button
        type="button"
        className={view === 'live' ? 'active' : undefined}
        aria-pressed={view === 'live'}
        onClick={() => onView('live')}
      >
        <strong>Live</strong>
        <small>What is happening now</small>
      </button>
      <button
        type="button"
        className={view === 'history' ? 'active' : undefined}
        aria-pressed={view === 'history'}
        onClick={() => onView('history')}
      >
        <strong>History</strong>
        <small>What happened before</small>
      </button>
      <button
        type="button"
        className={view === 'sessions' ? 'active' : undefined}
        aria-pressed={view === 'sessions'}
        onClick={() => onView('sessions')}
      >
        <strong>AI Sessions</strong>
        <small>Recorded session lifecycle</small>
      </button>
    </div>
  );
}
